import * as xmlHttpRequestProvider from './xmlHttpRequestProvider';
import * as superagentProvider from './superagentProvider';

export function getProvider(provider = '') {
    switch (provider.toLowerCase()) {
        case 'xmlhttprequest':
            return xmlHttpRequestProvider;
        case 'superagent':
            return superagentProvider;
        default:
            return xmlHttpRequestProvider;
    }
}


// WEBPACK FOOTER //
// ./src/services/api/utils/providerFactory.js